import { store } from '@/decorators/store';
import { MiscTimestamps } from '@/entities/MiscTimestamps';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'MiscTimestamps' })
export class MiscTimestampsStore extends AbstractEntityStore<MiscTimestamps> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'value';
  protected entityValueKey = 'value';
}
